function initialState() {
    return {
        decoder: ''
    }
}

export default {
    state: initialState(),
    getters: {
        DECODER: state => {
            return state.decoder
        },
    },
    mutations: {
        SET_DECODER(state, payload) {
            state.decoder = payload.decoder;
        },
        RESET(state) {
            const s = initialState();
            Object.keys(s).forEach(key => {
                state[key] = s[key]
            })
        }
    },
    actions: {
        UPDATE_DECODER: (context, payload) => {
            context.commit('SET_DECODER', payload);
        },
        RESET_DECODER: (context) => {
            context.commit('RESET', 'decoder');
        },
    }
}
